export const searchingDialog = {
  pleaseHavePacience: 'Bitte haben sie einen Moment Geduld',
  searchingForCraftsman: 'Unser System sucht in unserer Datenbank den passenden Anbieter für Sie',
  craftsmanFound: 'Wir haben passende Anbieter für Sie gefunden',
}
